import Callout from '../components/callout';

class ordersPagination {

    ordersPaginationAjax() {
        $('.order-list').on('click', '.pagination-item button', event => {
            event.stopPropagation();
            const paginationUrl = $(event.currentTarget).data('url');
            if (!paginationUrl) {
                return;
            }
            event.preventDefault();
            // $(this).trigger('search:sort', e);
            $.ajax({
                url: paginationUrl,
                data: {
                    selectedUrl: paginationUrl
                },
                method: 'GET',
                beforeSend: () => {
                    $('.order-list').addClass('loading');
                },
                success: response => {
                    $('.order-list').html(response);
                    $('.order-list').removeClass('loading');
                }
            });
        });
    }

}

const OrdersPagination = new ordersPagination();
export default OrdersPagination;


// WEBPACK FOOTER //
// ./assets/scripts/myaccount/ordersPagination.js